import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import AddFilled24Svg from './AddFilled24.svg.js';
import AddOutline24Svg from './AddOutline24.svg.js';
import AjankohtaistaOutline24Svg from './AjankohtaistaOutline24.svg.js';
import AlertOutline24Svg from './AlertOutline24.svg.js';
import ForbiddenOutline24Svg from './ForbiddenOutline24.svg.js';
import ArrowLeftOutline24Svg from './ArrowLeftOutline24.svg.js';
import ArrowRightOutline24Svg from './ArrowRightOutline24.svg.js';
import BackspaceOutline24Svg from './BackspaceOutline24.svg.js';
import BankAccountsOutline24Svg from './BankAccountsOutline24.svg.js';
import BarcodeOutline24Svg from './BarcodeOutline24.svg.js';
import BarcodeReaderDuotone24Svg from './BarcodeReaderDuotone24.svg.js';
import BedOutline24Svg from './BedOutline24.svg.js';
import BookmarkListOutline24Svg from './BookmarkListOutline24.svg.js';
import BookmarkOutline24Svg from './BookmarkOutline24.svg.js';
import BoxOutline24Svg from './BoxOutline24.svg.js';
import BusinessOutline24Svg from './BusinessOutline24.svg.js';
import CalendarDuotone24Svg from './CalendarDuotone24.svg.js';
import CalendarErrorDuotone24Svg from './CalendarErrorDuotone24.svg.js';
import CalendarOutline24Svg from './CalendarOutline24.svg.js';
import CameraOutline24Svg from './CameraOutline24.svg.js';
import CancelledFilled24Svg from './CancelledFilled24.svg.js';
import CarChargeOutline24Svg from './CarChargeOutline24.svg.js';
import CarOutline24Svg from './CarOutline24.svg.js';
import CarWashOutline24Svg from './CarWashOutline24.svg.js';
import CardCheckedDuotone24Svg from './CardCheckedDuotone24.svg.js';
import CardFilled24Svg from './CardFilled24.svg.js';
import CardOutline24Svg from './CardOutline24.svg.js';
import CategoryOutline24Svg from './CategoryOutline24.svg.js';
import ChangeOutline24Svg from './ChangeOutline24.svg.js';
import CheckboxEmptyOutline24Svg from './CheckboxEmptyOutline24.svg.js';
import CheckboxMarkedFilled24Svg from './CheckboxMarkedFilled24.svg.js';
import CheckboxMarkedOutline24Svg from './CheckboxMarkedOutline24.svg.js';
import ChecklistOutline24Svg from './ChecklistOutline24.svg.js';
import CheckmarkOutline24Svg from './CheckmarkOutline24.svg.js';
import ChevronBackOutline24Svg from './ChevronBackOutline24.svg.js';
import ChevronDownOutline24Svg from './ChevronDownOutline24.svg.js';
import ChevronForwardOutline24Svg from './ChevronForwardOutline24.svg.js';
import ChevronUpOutline24Svg from './ChevronUpOutline24.svg.js';
import ClearOutline24Svg from './ClearOutline24.svg.js';
import CommentFilled24Svg from './CommentFilled24.svg.js';
import CommentOutline24Svg from './CommentOutline24.svg.js';
import ComposeCheckedDuotone24Svg from './ComposeCheckedDuotone24.svg.js';
import ComposeOutline24Svg from './ComposeOutline24.svg.js';
import ConfirmedFilled24Svg from './ConfirmedFilled24.svg.js';
import ConfirmedOutline24Svg from './ConfirmedOutline24.svg.js';
import CouponOutline24Svg from './CouponOutline24.svg.js';
import CustomerServiceOutline24Svg from './CustomerServiceOutline24.svg.js';
import DeleteChangesDuotone24Svg from './DeleteChangesDuotone24.svg.js';
import DeleteOutline24Svg from './DeleteOutline24.svg.js';
import DeliveryChosenDuotone24Svg from './DeliveryChosenDuotone24.svg.js';
import DeliveryMethodOutline24Svg from './DeliveryMethodOutline24.svg.js';
import DeliveryOutline24Svg from './DeliveryOutline24.svg.js';
import DocumentOutline24Svg from './DocumentOutline24.svg.js';
import DoorOutline24Svg from './DoorOutline24.svg.js';
import DuplicateOutline24Svg from './DuplicateOutline24.svg.js';
import EditFilled24Svg from './EditFilled24.svg.js';
import EditOutline24Svg from './EditOutline24.svg.js';
import EmailOutline24Svg from './EmailOutline24.svg.js';
import ErrorFilled24Svg from './ErrorFilled24.svg.js';
import EyeOutline24Svg from './EyeOutline24.svg.js';
import FastTrackChosenDuotone24Svg from './FastTrackChosenDuotone24.svg.js';
import FastTrackOutline24Svg from './FastTrackOutline24.svg.js';
import QuickPickupChosenDuotone24Svg from './QuickPickupChosenDuotone24.svg.js';
import QuickPickupOutline24Svg from './QuickPickupOutline24.svg.js';
import FeedbackOutline24Svg from './FeedbackOutline24.svg.js';
import FilterOutline24Svg from './FilterOutline24.svg.js';
import FingerprintOutline24Svg from './FingerprintOutline24.svg.js';
import FoodOutline24Svg from './FoodOutline24.svg.js';
import GasOutline24Svg from './GasOutline24.svg.js';
import GetMoneyOutline24Svg from './GetMoneyOutline24.svg.js';
import GeolocationFilled24Svg from './GeolocationFilled24.svg.js';
import GeolocationOutline24Svg from './GeolocationOutline24.svg.js';
import GraphOutline24Svg from './GraphOutline24.svg.js';
import GroceriesCheckedDuotone24Svg from './GroceriesCheckedDuotone24.svg.js';
import GroceriesOutline24Svg from './GroceriesOutline24.svg.js';
import GroupOutline24Svg from './GroupOutline24.svg.js';
import HeartOutline24Svg from './HeartOutline24.svg.js';
import HistoryOutline24Svg from './HistoryOutline24.svg.js';
import HomeDeliveryOutline24Svg from './HomeDeliveryOutline24.svg.js';
import HomeFilled24Svg from './HomeFilled24.svg.js';
import HomeOutline24Svg from './HomeOutline24.svg.js';
import HotOutline24Svg from './HotOutline24.svg.js';
import HotelOutline24Svg from './HotelOutline24.svg.js';
import IdOutline24Svg from './IdOutline24.svg.js';
import InProgressFilled24Svg from './InProgressFilled24.svg.js';
import InfoFilled24Svg from './InfoFilled24.svg.js';
import InfoOutline24Svg from './InfoOutline24.svg.js';
import InvestmentsOutline24Svg from './InvestmentsOutline24.svg.js';
import InvoiceOutline24Svg from './InvoiceOutline24.svg.js';
import KauppaOutline24Svg from './KauppaOutline24.svg.js';
import LabelBrandOutline24Svg from './LabelBrandOutline24.svg.js';
import LightOffFilled24Svg from './LightOffFilled24.svg.js';
import LightOnOutline24Svg from './LightOnOutline24.svg.js';
import LinkOutline24Svg from './LinkOutline24.svg.js';
import LoansOutline24Svg from './LoansOutline24.svg.js';
import LocateFilled24Svg from './LocateFilled24.svg.js';
import LocateOutline24Svg from './LocateOutline24.svg.js';
import LocationFilled24Svg from './LocationFilled24.svg.js';
import LocationMapOutline24Svg from './LocationMapOutline24.svg.js';
import LocationOutline24Svg from './LocationOutline24.svg.js';
import LockFilled24Svg from './LockFilled24.svg.js';
import LockOutline24Svg from './LockOutline24.svg.js';
import LogoutOutline24Svg from './LogoutOutline24.svg.js';
import MaksutapaetuOutline24Svg from './MaksutapaetuOutline24.svg.js';
import MapListOutline24Svg from './MapListOutline24.svg.js';
import MapOutline24Svg from './MapOutline24.svg.js';
import MessagesOutline24Svg from './MessagesOutline24.svg.js';
import MessagesUnreadDuotone24Svg from './MessagesUnreadDuotone24.svg.js';
import MinusOutline24Svg from './MinusOutline24.svg.js';
import MmOutline24Svg from './MmOutline24.svg.js';
import MobileOutline24Svg from './MobileOutline24.svg.js';
import ModifyOrderOutline24Svg from './ModifyOrderOutline24.svg.js';
import MoodAngryOutline24Svg from './MoodAngryOutline24.svg.js';
import MoodHappyOutline24Svg from './MoodHappyOutline24.svg.js';
import MoodLaughOutline24Svg from './MoodLaughOutline24.svg.js';
import MoodUnhappyOutline24Svg from './MoodUnhappyOutline24.svg.js';
import NaviOutline24Svg from './NaviOutline24.svg.js';
import NewFilled24Svg from './NewFilled24.svg.js';
import NfcOutline24Svg from './NfcOutline24.svg.js';
import NumpadQwertyOutline24Svg from './NumpadQwertyOutline24.svg.js';
import OpeningHoursCheckedDuotone24Svg from './OpeningHoursCheckedDuotone24.svg.js';
import OpeningHoursClosedOutline24Svg from './OpeningHoursClosedOutline24.svg.js';
import OpeningHoursOpenDuotone24Svg from './OpeningHoursOpenDuotone24.svg.js';
import OpeningHoursOutline24Svg from './OpeningHoursOutline24.svg.js';
import OrderNumber24Svg from './OrderNumber24.svg.js';
import PaperitonAsiointiOutline24Svg from './PaperitonAsiointiOutline24.svg.js';
import PartyOutline24Svg from './PartyOutline24.svg.js';
import PaydayOutline24Svg from './PaydayOutline24.svg.js';
import PaymentTerminalOutline24Svg from './PaymentTerminalOutline24.svg.js';
import PhoneOutline24Svg from './PhoneOutline24.svg.js';
import PlayOutline24Svg from './PlayOutline24.svg.js';
import PlusOutline24Svg from './PlusOutline24.svg.js';
import PrinterOutline24Svg from './PrinterOutline24.svg.js';
import PrivacyStatementOutline24Svg from './PrivacyStatementOutline24.svg.js';
import QrCodeOutline24Svg from './QrCodeOutline24.svg.js';
import QuestionMarkOutline24Svg from './QuestionMarkOutline24.svg.js';
import RadioActiveOutline24Svg from './RadioActiveOutline24.svg.js';
import ReceiptArchiveOutline24Svg from './ReceiptArchiveOutline24.svg.js';
import ReceiptOutline24Svg from './ReceiptOutline24.svg.js';
import RecipeOutline24Svg from './RecipeOutline24.svg.js';
import ReplaceOutline24Svg from './ReplaceOutline24.svg.js';
import RestaurantOutline24Svg from './RestaurantOutline24.svg.js';
import RiskIndicatorFilled24Svg from './RiskIndicatorFilled24.svg.js';
import RiskIndicatorOutline24Svg from './RiskIndicatorOutline24.svg.js';
import RouteOutline24Svg from './RouteOutline24.svg.js';
import SaverOutline24Svg from './SaverOutline24.svg.js';
import SbankFilled24Svg from './SbankFilled24.svg.js';
import SbankOutline24Svg from './SbankOutline24.svg.js';
import ScaleOutline24Svg from './ScaleOutline24.svg.js';
import ScardsOutline24Svg from './ScardsOutline24.svg.js';
import SearchOutline24Svg from './SearchOutline24.svg.js';
import SelectionOutline24Svg from './SelectionOutline24.svg.js';
import SendMoneyOutline24Svg from './SendMoneyOutline24.svg.js';
import SettingsOutline24Svg from './SettingsOutline24.svg.js';
import ShareOutline24Svg from './ShareOutline24.svg.js';
import ShoppingOutline24Svg from './ShoppingOutline24.svg.js';
import SiconFilled24Svg from './SiconFilled24.svg.js';
import SiconOutline24Svg from './SiconOutline24.svg.js';
import SiirtoOutline24Svg from './SiirtoOutline24.svg.js';
import SmartListOutline24Svg from './SmartListOutline24.svg.js';
import StarFilled24Svg from './StarFilled24.svg.js';
import StarOutline24Svg from './StarOutline24.svg.js';
import StockmannOutline24Svg from './StockmannOutline24.svg.js';
import StoreChosenDuotone24Svg from './StoreChosenDuotone24.svg.js';
import StoreOutline24Svg from './StoreOutline24.svg.js';
import ThreeDotsHorizontalFilled24Svg from './ThreeDotsHorizontalFilled24.svg.js';
import ThreeDotsHorizontalOutline24Svg from './ThreeDotsHorizontalOutline24.svg.js';
import ThreeDotsVerticalFilled24Svg from './ThreeDotsVerticalFilled24.svg.js';
import ThreeDotsVerticalOutline24Svg from './ThreeDotsVerticalOutline24.svg.js';
import TransactionNotificationOutline24Svg from './TransactionNotificationOutline24.svg.js';
import TransferOutline24Svg from './TransferOutline24.svg.js';
import TrophyOutline24Svg from './TrophyOutline24.svg.js';
import UserFilled24Svg from './UserFilled24.svg.js';
import UserOutline24Svg from './UserOutline24.svg.js';
import UtilityOutline24Svg from './UtilityOutline24.svg.js';
import WalletEmptyOutline24Svg from './WalletEmptyOutline24.svg.js';
import WalletFilled24Svg from './WalletFilled24.svg.js';
import WarrantyReceiptOutline24Svg from './WarrantyReceiptOutline24.svg.js';
import WebOutline24Svg from './WebOutline24.svg.js';
import AmericanExpress24Svg from './AmericanExpress24.svg.js';
import Cirrus24Svg from './Cirrus24.svg.js';
import DinersClub24Svg from './DinersClub24.svg.js';
import Discover24Svg from './Discover24.svg.js';
import Ikano24Svg from './Ikano24.svg.js';
import JCB24Svg from './JCB24.svg.js';
import Maestro24Svg from './Maestro24.svg.js';
import MasterCard24Svg from './MasterCard24.svg.js';
import Sbonus24Svg from './Sbonus24.svg.js';
import SVisa24Svg from './Svisa24.svg.js';
import Sbusiness24Svg from './Sbusiness24.svg.js';
import Stockmann24Svg from './Stockmann24.svg.js';
import UnionPay24Svg from './UnionPay24.svg.js';
import Visa24Svg from './Visa24.svg.js';
import CardUnknown24Svg from './CardUnknown24.svg.js';
import { Icon } from '../../components/Icon/Icon.js';

var AddFilled24 = function AddFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(AddFilled24Svg, null)
  }));
};
var AddOutline24 = function AddOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(AddOutline24Svg, null)
  }));
};
var AjankohtaistaOutline24 = function AjankohtaistaOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(AjankohtaistaOutline24Svg, null)
  }));
};
var AlertOutline24 = function AlertOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(AlertOutline24Svg, null)
  }));
};
var ForbiddenOutline24 = function ForbiddenOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ForbiddenOutline24Svg, null)
  }));
};
var ArrowLeftOutline24 = function ArrowLeftOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ArrowLeftOutline24Svg, null)
  }));
};
var ArrowRightOutline24 = function ArrowRightOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ArrowRightOutline24Svg, null)
  }));
};
var BackspaceOutline24 = function BackspaceOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BackspaceOutline24Svg, null)
  }));
};
var BankAccountsOutline24 = function BankAccountsOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BankAccountsOutline24Svg, null)
  }));
};
var BarcodeOutline24 = function BarcodeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BarcodeOutline24Svg, null)
  }));
};
var BarcodeReaderDuotone24 = function BarcodeReaderDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BarcodeReaderDuotone24Svg, null)
  }));
};
var BedOutline24 = function BedOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BedOutline24Svg, null)
  }));
};
var BookmarkListOutline24 = function BookmarkListOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BookmarkListOutline24Svg, null)
  }));
};
var BookmarkOutline24 = function BookmarkOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BookmarkOutline24Svg, null)
  }));
};
var BoxOutline24 = function BoxOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BoxOutline24Svg, null)
  }));
};
var BusinessOutline24 = function BusinessOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BusinessOutline24Svg, null)
  }));
};
var CalendarDuotone24 = function CalendarDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CalendarDuotone24Svg, null)
  }));
};
var CalendarErrorDuotone24 = function CalendarErrorDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CalendarErrorDuotone24Svg, null)
  }));
};
var CalendarOutline24 = function CalendarOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CalendarOutline24Svg, null)
  }));
};
var CameraOutline24 = function CameraOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CameraOutline24Svg, null)
  }));
};
var CancelledFilled24 = function CancelledFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CancelledFilled24Svg, null)
  }));
};
var CarChargeOutline24 = function CarChargeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CarChargeOutline24Svg, null)
  }));
};
var CarOutline24 = function CarOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CarOutline24Svg, null)
  }));
};
var CarWashOutline24 = function CarWashOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CarWashOutline24Svg, null)
  }));
};
var CardCheckedDuotone24 = function CardCheckedDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CardCheckedDuotone24Svg, null)
  }));
};
var CardFilled24 = function CardFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CardFilled24Svg, null)
  }));
};
var CardOutline24 = function CardOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CardOutline24Svg, null)
  }));
};
var CategoryOutline24 = function CategoryOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CategoryOutline24Svg, null)
  }));
};
var ChangeOutline24 = function ChangeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChangeOutline24Svg, null)
  }));
};
var CheckboxEmptyOutline24 = function CheckboxEmptyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckboxEmptyOutline24Svg, null)
  }));
};
var CheckboxMarkedFilled24 = function CheckboxMarkedFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckboxMarkedFilled24Svg, null)
  }));
};
var CheckboxMarkedOutline24 = function CheckboxMarkedOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckboxMarkedOutline24Svg, null)
  }));
};
var ChecklistOutline24 = function ChecklistOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChecklistOutline24Svg, null)
  }));
};
var CheckmarkOutline24 = function CheckmarkOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckmarkOutline24Svg, null)
  }));
};
var ChevronBackOutline24 = function ChevronBackOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronBackOutline24Svg, null)
  }));
};
var ChevronDownOutline24 = function ChevronDownOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronDownOutline24Svg, null)
  }));
};
var ChevronForwardOutline24 = function ChevronForwardOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronForwardOutline24Svg, null)
  }));
};
var ChevronUpOutline24 = function ChevronUpOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronUpOutline24Svg, null)
  }));
};
var ClearOutline24 = function ClearOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ClearOutline24Svg, null)
  }));
};
var CommentFilled24 = function CommentFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CommentFilled24Svg, null)
  }));
};
var CommentOutline24 = function CommentOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CommentOutline24Svg, null)
  }));
};
var ComposeCheckedDuotone24 = function ComposeCheckedDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ComposeCheckedDuotone24Svg, null)
  }));
};
var ComposeOutline24 = function ComposeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ComposeOutline24Svg, null)
  }));
};
var ConfirmedFilled24 = function ConfirmedFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ConfirmedFilled24Svg, null)
  }));
};
var ConfirmedOutline24 = function ConfirmedOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ConfirmedOutline24Svg, null)
  }));
};
var CouponOutline24 = function CouponOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CouponOutline24Svg, null)
  }));
};
var CustomerServiceOutline24 = function CustomerServiceOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CustomerServiceOutline24Svg, null)
  }));
};
var DeleteChangesDuotone24 = function DeleteChangesDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeleteChangesDuotone24Svg, null)
  }));
};
var DeleteOutline24 = function DeleteOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeleteOutline24Svg, null)
  }));
};
var DeliveryChosenDuotone24 = function DeliveryChosenDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeliveryChosenDuotone24Svg, null)
  }));
};
var DeliveryMethodOutline24 = function DeliveryMethodOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeliveryMethodOutline24Svg, null)
  }));
};
var DeliveryOutline24 = function DeliveryOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeliveryOutline24Svg, null)
  }));
};
var DocumentOutline24 = function DocumentOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DocumentOutline24Svg, null)
  }));
};
var DoorOutline24 = function DoorOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DoorOutline24Svg, null)
  }));
};
var DuplicateOutline24 = function DuplicateOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DuplicateOutline24Svg, null)
  }));
};
var EditFilled24 = function EditFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EditFilled24Svg, null)
  }));
};
var EditOutline24 = function EditOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EditOutline24Svg, null)
  }));
};
var EmailOutline24 = function EmailOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EmailOutline24Svg, null)
  }));
};
var ErrorFilled24 = function ErrorFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ErrorFilled24Svg, null)
  }));
};
var EyeOutline24 = function EyeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EyeOutline24Svg, null)
  }));
};
var FastTrackChosenDuotone24 = function FastTrackChosenDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FastTrackChosenDuotone24Svg, null)
  }));
};
var FastTrackOutline24 = function FastTrackOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FastTrackOutline24Svg, null)
  }));
};
var QuickPickupChosenDuotone24 = function QuickPickupChosenDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(QuickPickupChosenDuotone24Svg, null)
  }));
};
var QuickPickupOutline24 = function QuickPickupOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(QuickPickupOutline24Svg, null)
  }));
};
var FeedbackOutline24 = function FeedbackOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FeedbackOutline24Svg, null)
  }));
};
var FilterOutline24 = function FilterOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FilterOutline24Svg, null)
  }));
};
var FingerprintOutline24 = function FingerprintOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FingerprintOutline24Svg, null)
  }));
};
var FoodOutline24 = function FoodOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FoodOutline24Svg, null)
  }));
};
var GasOutline24 = function GasOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GasOutline24Svg, null)
  }));
};
var GetMoneyOutline24 = function GetMoneyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GetMoneyOutline24Svg, null)
  }));
};
var GeolocationFilled24 = function GeolocationFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GeolocationFilled24Svg, null)
  }));
};
var GeolocationOutline24 = function GeolocationOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GeolocationOutline24Svg, null)
  }));
};
var GraphOutline24 = function GraphOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GraphOutline24Svg, null)
  }));
};
var GroceriesCheckedDuotone24 = function GroceriesCheckedDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GroceriesCheckedDuotone24Svg, null)
  }));
};
var GroceriesOutline24 = function GroceriesOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GroceriesOutline24Svg, null)
  }));
};
var GroupOutline24 = function GroupOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GroupOutline24Svg, null)
  }));
};
var HeartOutline24 = function HeartOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HeartOutline24Svg, null)
  }));
};
var HistoryOutline24 = function HistoryOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HistoryOutline24Svg, null)
  }));
};
var HomeDeliveryOutline24 = function HomeDeliveryOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HomeDeliveryOutline24Svg, null)
  }));
};
var HomeFilled24 = function HomeFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HomeFilled24Svg, null)
  }));
};
var HomeOutline24 = function HomeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HomeOutline24Svg, null)
  }));
};
var HotOutline24 = function HotOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HotOutline24Svg, null)
  }));
};
var HotelOutline24 = function HotelOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HotelOutline24Svg, null)
  }));
};
var IdOutline24 = function IdOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(IdOutline24Svg, null)
  }));
};
var InProgressFilled24 = function InProgressFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InProgressFilled24Svg, null)
  }));
};
var InfoFilled24 = function InfoFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InfoFilled24Svg, null)
  }));
};
var InfoOutline24 = function InfoOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InfoOutline24Svg, null)
  }));
};
var InvestmentsOutline24 = function InvestmentsOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InvestmentsOutline24Svg, null)
  }));
};
var InvoiceOutline24 = function InvoiceOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InvoiceOutline24Svg, null)
  }));
};
var KauppaOutline24 = function KauppaOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(KauppaOutline24Svg, null)
  }));
};
var LabelBrandOutline24 = function LabelBrandOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LabelBrandOutline24Svg, null)
  }));
};
var LightOffFilled24 = function LightOffFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LightOffFilled24Svg, null)
  }));
};
var LightOnOutline24 = function LightOnOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LightOnOutline24Svg, null)
  }));
};
var LinkOutline24 = function LinkOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LinkOutline24Svg, null)
  }));
};
var LoansOutline24 = function LoansOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LoansOutline24Svg, null)
  }));
};
var LocateFilled24 = function LocateFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocateFilled24Svg, null)
  }));
};
var LocateOutline24 = function LocateOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocateOutline24Svg, null)
  }));
};
var LocationFilled24 = function LocationFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationFilled24Svg, null)
  }));
};
var LocationMapOutline24 = function LocationMapOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationMapOutline24Svg, null)
  }));
};
var LocationOutline24 = function LocationOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationOutline24Svg, null)
  }));
};
var LockFilled24 = function LockFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LockFilled24Svg, null)
  }));
};
var LockOutline24 = function LockOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LockOutline24Svg, null)
  }));
};
var LogoutOutline24 = function LogoutOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LogoutOutline24Svg, null)
  }));
};
var MaksutapaetuOutline24 = function MaksutapaetuOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MaksutapaetuOutline24Svg, null)
  }));
};
var MapListOutline24 = function MapListOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MapListOutline24Svg, null)
  }));
};
var MapOutline24 = function MapOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MapOutline24Svg, null)
  }));
};
var MessagesOutline24 = function MessagesOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MessagesOutline24Svg, null)
  }));
};
var MessagesUnreadDuotone24 = function MessagesUnreadDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MessagesUnreadDuotone24Svg, null)
  }));
};
var MinusOutline24 = function MinusOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MinusOutline24Svg, null)
  }));
};
var MmOutline24 = function MmOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MmOutline24Svg, null)
  }));
};
var MobileOutline24 = function MobileOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MobileOutline24Svg, null)
  }));
};
var ModifyOrderOutline24 = function ModifyOrderOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ModifyOrderOutline24Svg, null)
  }));
};
var MoodAngryOutline24 = function MoodAngryOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MoodAngryOutline24Svg, null)
  }));
};
var MoodHappyOutline24 = function MoodHappyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MoodHappyOutline24Svg, null)
  }));
};
var MoodLaughOutline24 = function MoodLaughOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MoodLaughOutline24Svg, null)
  }));
};
var MoodUnhappyOutline24 = function MoodUnhappyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MoodUnhappyOutline24Svg, null)
  }));
};
var NaviOutline24 = function NaviOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(NaviOutline24Svg, null)
  }));
};
var NewFilled24 = function NewFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(NewFilled24Svg, null)
  }));
};
var NfcOutline24 = function NfcOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(NfcOutline24Svg, null)
  }));
};
var NumpadQwertyOutline24 = function NumpadQwertyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(NumpadQwertyOutline24Svg, null)
  }));
};
var OpeningHoursCheckedDuotone24 = function OpeningHoursCheckedDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OpeningHoursCheckedDuotone24Svg, null)
  }));
};
var OpeningHoursClosedOutline24 = function OpeningHoursClosedOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OpeningHoursClosedOutline24Svg, null)
  }));
};
var OpeningHoursOpenDuotone24 = function OpeningHoursOpenDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OpeningHoursOpenDuotone24Svg, null)
  }));
};
var OpeningHoursOutline24 = function OpeningHoursOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OpeningHoursOutline24Svg, null)
  }));
};
var OrderNumber24 = function OrderNumber24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OrderNumber24Svg, null)
  }));
};
var PaperitonAsiointiOutline24 = function PaperitonAsiointiOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PaperitonAsiointiOutline24Svg, null)
  }));
};
var PartyOutline24 = function PartyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PartyOutline24Svg, null)
  }));
};
var PaydayOutline24 = function PaydayOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PaydayOutline24Svg, null)
  }));
};
var PaymentTerminalOutline24 = function PaymentTerminalOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PaymentTerminalOutline24Svg, null)
  }));
};
var PhoneOutline24 = function PhoneOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PhoneOutline24Svg, null)
  }));
};
var PlayOutline24 = function PlayOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PlayOutline24Svg, null)
  }));
};
var PlusOutline24 = function PlusOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PlusOutline24Svg, null)
  }));
};
var PrinterOutline24 = function PrinterOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PrinterOutline24Svg, null)
  }));
};
var PrivacyStatementOutline24 = function PrivacyStatementOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PrivacyStatementOutline24Svg, null)
  }));
};
var QrCodeOutline24 = function QrCodeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(QrCodeOutline24Svg, null)
  }));
};
var QuestionMarkOutline24 = function QuestionMarkOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(QuestionMarkOutline24Svg, null)
  }));
};
var RadioActiveOutline24 = function RadioActiveOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RadioActiveOutline24Svg, null)
  }));
};
var ReceiptArchiveOutline24 = function ReceiptArchiveOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReceiptArchiveOutline24Svg, null)
  }));
};
var ReceiptOutline24 = function ReceiptOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReceiptOutline24Svg, null)
  }));
};
var RecipeOutline24 = function RecipeOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RecipeOutline24Svg, null)
  }));
};
var ReplaceOutline24 = function ReplaceOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReplaceOutline24Svg, null)
  }));
};
var RestaurantOutline24 = function RestaurantOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RestaurantOutline24Svg, null)
  }));
};
var RiskIndicatorFilled24 = function RiskIndicatorFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RiskIndicatorFilled24Svg, null)
  }));
};
var RiskIndicatorOutline24 = function RiskIndicatorOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RiskIndicatorOutline24Svg, null)
  }));
};
var RouteOutline24 = function RouteOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RouteOutline24Svg, null)
  }));
};
var SaverOutline24 = function SaverOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SaverOutline24Svg, null)
  }));
};
var SbankFilled24 = function SbankFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SbankFilled24Svg, null)
  }));
};
var SbankOutline24 = function SbankOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SbankOutline24Svg, null)
  }));
};
var ScaleOutline24 = function ScaleOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ScaleOutline24Svg, null)
  }));
};
var ScardsOutline24 = function ScardsOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ScardsOutline24Svg, null)
  }));
};
var SearchOutline24 = function SearchOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SearchOutline24Svg, null)
  }));
};
var SelectionOutline24 = function SelectionOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SelectionOutline24Svg, null)
  }));
};
var SendMoneyOutline24 = function SendMoneyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SendMoneyOutline24Svg, null)
  }));
};
var SettingsOutline24 = function SettingsOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SettingsOutline24Svg, null)
  }));
};
var ShareOutline24 = function ShareOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ShareOutline24Svg, null)
  }));
};
var ShoppingOutline24 = function ShoppingOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ShoppingOutline24Svg, null)
  }));
};
var SiconFilled24 = function SiconFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SiconFilled24Svg, null)
  }));
};
var SiconOutline24 = function SiconOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SiconOutline24Svg, null)
  }));
};
var SiirtoOutline24 = function SiirtoOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SiirtoOutline24Svg, null)
  }));
};
var SmartListOutline24 = function SmartListOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SmartListOutline24Svg, null)
  }));
};
var StarFilled24 = function StarFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StarFilled24Svg, null)
  }));
};
var StarOutline24 = function StarOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StarOutline24Svg, null)
  }));
};
var StockmannOutline24 = function StockmannOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StockmannOutline24Svg, null)
  }));
};
var StoreChosenDuotone24 = function StoreChosenDuotone24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StoreChosenDuotone24Svg, null)
  }));
};
var StoreOutline24 = function StoreOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StoreOutline24Svg, null)
  }));
};
var ThreeDotsHorizontalFilled24 = function ThreeDotsHorizontalFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsHorizontalFilled24Svg, null)
  }));
};
var ThreeDotsHorizontalOutline24 = function ThreeDotsHorizontalOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsHorizontalOutline24Svg, null)
  }));
};
var ThreeDotsVerticalFilled24 = function ThreeDotsVerticalFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsVerticalFilled24Svg, null)
  }));
};
var ThreeDotsVerticalOutline24 = function ThreeDotsVerticalOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsVerticalOutline24Svg, null)
  }));
};
var TransactionNotificationOutline24 = function TransactionNotificationOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(TransactionNotificationOutline24Svg, null)
  }));
};
var TransferOutline24 = function TransferOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(TransferOutline24Svg, null)
  }));
};
var TrophyOutline24 = function TrophyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(TrophyOutline24Svg, null)
  }));
};
var UserFilled24 = function UserFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UserFilled24Svg, null)
  }));
};
var UserOutline24 = function UserOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UserOutline24Svg, null)
  }));
};
var UtilityOutline24 = function UtilityOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UtilityOutline24Svg, null)
  }));
};
var WalletEmptyOutline24 = function WalletEmptyOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(WalletEmptyOutline24Svg, null)
  }));
};
var WalletFilled24 = function WalletFilled24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(WalletFilled24Svg, null)
  }));
};
var WarrantyReceiptOutline24 = function WarrantyReceiptOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(WarrantyReceiptOutline24Svg, null)
  }));
};
var WebOutline24 = function WebOutline24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(WebOutline24Svg, null)
  }));
};
var CardUnknown24 = function CardUnknown24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CardUnknown24Svg, null)
  }));
};
var AmericanExpress24 = function AmericanExpress24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(AmericanExpress24Svg, null)
  }));
};
var Cirrus24 = function Cirrus24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Cirrus24Svg, null)
  }));
};
var DinersClub24 = function DinersClub24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DinersClub24Svg, null)
  }));
};
var Discover24 = function Discover24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Discover24Svg, null)
  }));
};
var Ikano24 = function Ikano24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Ikano24Svg, null)
  }));
};
var JCB24 = function JCB24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(JCB24Svg, null)
  }));
};
var Maestro24 = function Maestro24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Maestro24Svg, null)
  }));
};
var MasterCard24 = function MasterCard24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MasterCard24Svg, null)
  }));
};
var Sbonus24 = function Sbonus24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Sbonus24Svg, null)
  }));
};
var Sbusiness24 = function Sbusiness24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Sbusiness24Svg, null)
  }));
};
var Svisa24 = function Svisa24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SVisa24Svg, null)
  }));
};
var Stockmann24 = function Stockmann24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Stockmann24Svg, null)
  }));
};
var UnionPay24 = function UnionPay24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UnionPay24Svg, null)
  }));
};
var Visa24 = function Visa24(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Visa24Svg, null)
  }));
};

export { AddFilled24, AddOutline24, AjankohtaistaOutline24, AlertOutline24, AmericanExpress24, ArrowLeftOutline24, ArrowRightOutline24, BackspaceOutline24, BankAccountsOutline24, BarcodeOutline24, BarcodeReaderDuotone24, BedOutline24, BookmarkListOutline24, BookmarkOutline24, BoxOutline24, BusinessOutline24, CalendarDuotone24, CalendarErrorDuotone24, CalendarOutline24, CameraOutline24, CancelledFilled24, CarChargeOutline24, CarOutline24, CarWashOutline24, CardCheckedDuotone24, CardFilled24, CardOutline24, CardUnknown24, CategoryOutline24, ChangeOutline24, CheckboxEmptyOutline24, CheckboxMarkedFilled24, CheckboxMarkedOutline24, ChecklistOutline24, CheckmarkOutline24, ChevronBackOutline24, ChevronDownOutline24, ChevronForwardOutline24, ChevronUpOutline24, Cirrus24, ClearOutline24, CommentFilled24, CommentOutline24, ComposeCheckedDuotone24, ComposeOutline24, ConfirmedFilled24, ConfirmedOutline24, CouponOutline24, CustomerServiceOutline24, DeleteChangesDuotone24, DeleteOutline24, DeliveryChosenDuotone24, DeliveryMethodOutline24, DeliveryOutline24, DinersClub24, Discover24, DocumentOutline24, DoorOutline24, DuplicateOutline24, EditFilled24, EditOutline24, EmailOutline24, ErrorFilled24, EyeOutline24, FastTrackChosenDuotone24, FastTrackOutline24, FeedbackOutline24, FilterOutline24, FingerprintOutline24, FoodOutline24, ForbiddenOutline24, GasOutline24, GeolocationFilled24, GeolocationOutline24, GetMoneyOutline24, GraphOutline24, GroceriesCheckedDuotone24, GroceriesOutline24, GroupOutline24, HeartOutline24, HistoryOutline24, HomeDeliveryOutline24, HomeFilled24, HomeOutline24, HotOutline24, HotelOutline24, IdOutline24, Ikano24, InProgressFilled24, InfoFilled24, InfoOutline24, InvestmentsOutline24, InvoiceOutline24, JCB24, KauppaOutline24, LabelBrandOutline24, LightOffFilled24, LightOnOutline24, LinkOutline24, LoansOutline24, LocateFilled24, LocateOutline24, LocationFilled24, LocationMapOutline24, LocationOutline24, LockFilled24, LockOutline24, LogoutOutline24, Maestro24, MaksutapaetuOutline24, MapListOutline24, MapOutline24, MasterCard24, MessagesOutline24, MessagesUnreadDuotone24, MinusOutline24, MmOutline24, MobileOutline24, ModifyOrderOutline24, MoodAngryOutline24, MoodHappyOutline24, MoodLaughOutline24, MoodUnhappyOutline24, NaviOutline24, NewFilled24, NfcOutline24, NumpadQwertyOutline24, OpeningHoursCheckedDuotone24, OpeningHoursClosedOutline24, OpeningHoursOpenDuotone24, OpeningHoursOutline24, OrderNumber24, PaperitonAsiointiOutline24, PartyOutline24, PaydayOutline24, PaymentTerminalOutline24, PhoneOutline24, PlayOutline24, PlusOutline24, PrinterOutline24, PrivacyStatementOutline24, QrCodeOutline24, QuestionMarkOutline24, QuickPickupChosenDuotone24, QuickPickupOutline24, RadioActiveOutline24, ReceiptArchiveOutline24, ReceiptOutline24, RecipeOutline24, ReplaceOutline24, RestaurantOutline24, RiskIndicatorFilled24, RiskIndicatorOutline24, RouteOutline24, SaverOutline24, SbankFilled24, SbankOutline24, Sbonus24, Sbusiness24, ScaleOutline24, ScardsOutline24, SearchOutline24, SelectionOutline24, SendMoneyOutline24, SettingsOutline24, ShareOutline24, ShoppingOutline24, SiconFilled24, SiconOutline24, SiirtoOutline24, SmartListOutline24, StarFilled24, StarOutline24, Stockmann24, StockmannOutline24, StoreChosenDuotone24, StoreOutline24, Svisa24, ThreeDotsHorizontalFilled24, ThreeDotsHorizontalOutline24, ThreeDotsVerticalFilled24, ThreeDotsVerticalOutline24, TransactionNotificationOutline24, TransferOutline24, TrophyOutline24, UnionPay24, UserFilled24, UserOutline24, UtilityOutline24, Visa24, WalletEmptyOutline24, WalletFilled24, WarrantyReceiptOutline24, WebOutline24 };
//# sourceMappingURL=index.js.map
